
// Definición de defaults

export const defaultTipoParte: TipoParteProps = {
    idTipoParte:  0,
    descripcion:    '',
    activo:         false
};

// Creación de interfaces

export interface TipoParteProps{
    idTipoParte:  number;
    descripcion:    string;
    activo:         boolean;
}
